import { Card, CardMedia, CardContent, Typography, IconButton, Box, StarOutlineIcon, 
    StarRateIcon, LocationOnIcon, CloseIcon } from 'src/components';
import { useIsMobile, useNetworkStatus } from 'src/hooks';
import { getCategorySymbol } from 'src/data';
import { useFeatureTravellerStore } from 'src/stores';

import placeholderImage from 'src/assets/placeholders/light-grey-140x140.png';

export default function FeaturePopupCard({ onClose, handleFavouriteClick, isFavourite, favouriteRequestLoading, onOpenDetails }) {
    const selectedFeature = useFeatureTravellerStore((state) => state.selectedFeature);
    
    const isMobile = useIsMobile();
    const online = useNetworkStatus();
    
    if (!selectedFeature) return null;

    const hasImage = selectedFeature.images !== null && selectedFeature.images !== undefined && selectedFeature.images !== "[]" && selectedFeature.images?.length !== 0;
    const imageToShow = hasImage && online ? selectedFeature.images[0] : placeholderImage;

    const titlePreview = selectedFeature.title?.slice(0, 18) + (selectedFeature.title?.length > 18 ? '...' : '');
    const descriptionPreview = selectedFeature.description?.slice(0, 77) + (selectedFeature.description?.length > 77 ? '...' : '');
    const categoryIconPath = getCategorySymbol(selectedFeature.category);

    const cardStyles = {
        width: isMobile ? '90%' : 340,
        height: hasImage ? 100 : 'fit-content',
        display: 'flex',
        position: 'fixed',
        bottom: isMobile ? 'calc(75px + var(--safe-area-bottom))' : 50,
        left: isMobile ? '5%' : 50,
        zIndex: 1000,
        borderRadius: 2,
        boxShadow: 6,
        cursor: 'pointer',
        backgroundColor: 'white',
        overflow: 'hidden'
    };

    return (
        <Card sx={cardStyles} onClick={() => onOpenDetails(selectedFeature)}>

        {hasImage ?
            <CardMedia
                component="img"
                image={imageToShow}
                loading="lazy"
                alt={selectedFeature.name}
                onError={(e) => {
                    e.currentTarget.src = placeholderImage;
                }}
                sx={{ width: 80, height: '100%', objectFit: 'cover', marginRight: '4px', backgroundColor: '#f0f0f0' }}
            /> : <></>}

        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            flex: 1}}>

                <CardContent sx={{ padding: 1, display: 'flex', flexDirection: 'column'}}>

                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        mb: 0.5}}>
                            
                            <Typography variant="h5" fontWeight="bold">
                                {hasImage ?
                                    titlePreview : selectedFeature.title}
                            </Typography>
                            
                            <Box sx={{ display: 'flex', justifyContent: 'row', alignItems: 'center' }}>

                                {categoryIconPath && (
                                    <Box component="img"
                                        src={categoryIconPath}
                                        alt={selectedFeature.category}
                                        sx={{ width: 20, height: 20, mr: 1 }}
                                    />
                                )}

                                {selectedFeature.googleMapsUrl && (
                                    <IconButton 
                                        href={selectedFeature.googleMapsUrl} 
                                        target="blank" 
                                        size="small"
                                        onClick={(e) => e.stopPropagation()}>
                                        <LocationOnIcon fontSize="small" />
                                    </IconButton>
                                )}

                                <IconButton 
                                    size="small" 
                                    loading={favouriteRequestLoading}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleFavouriteClick(selectedFeature.id);
                                    }}>
                                    {isFavourite ? 
                                        <StarRateIcon fontSize="small" /> 
                                    : <StarOutlineIcon fontSize="small" />}
                                </IconButton>

                                <IconButton size="small" onClick={(e) => {
                                        e.stopPropagation();
                                        onClose();
                                    }}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>

                            </Box>

                    </Box>

                    <Typography variant="body2" color="text.secondary">
                        {hasImage ?
                            descriptionPreview : selectedFeature.description}
                    </Typography>

                </CardContent>
        </Box>

        </Card>
    );
}
